import type { CSSProperties } from 'react';

/** Iconițe 24×24 cu contur (stilul mockup-ului); `currentColor`. */
const PATHS: Record<string, string> = {
  dashboard: 'M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-4H4zM14 7h6V4h-6z',
  locker:
    'M5 3h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1ZM12 3v18M4 9h16M4 15h16',
  map: 'M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14',
  operations: 'M4 7.5 12 3l8 4.5-8 4.5-8-4.5ZM4 7.5V17l8 4 8-4V7.5M12 12v9',
  key: 'M8 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm4-4h9M17 12v3M20 12v2',
  document: 'M6 2.8h8l4 4V21H6zM14 2.8V7h4M9 11h6M9 15h6',
  alert: 'M12 3 21 20H3L12 3ZM12 10v4M12 17h.01',
  report: 'M4 20h16M6 16V9M10 16V5M14 16v-4M18 16V8',
  users:
    'M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM21 21v-2a4 4 0 0 0-3-3.9M16 3.1a3.5 3.5 0 0 1 0 6.8',
  shield: 'M12 3 20 6v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3ZM9 12l2 2 4-4',
  org: 'M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6M9 10h.01M15 10h.01M9 13h.01M15 13h.01',
  rules: 'M4 6h10M4 12h16M4 18h8M18 4v4M16 6h4',
  integrations: 'M9 3v4M15 3v4M6 7h12v5a6 6 0 0 1-12 0V7ZM12 18v3',
  audit: 'M4 5h16v14H4zM8 9h8M8 13h5M4 17h16',
  settings:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.1l2-1.5-2-3.4-2.3 1a7.4 7.4 0 0 0-1.9-1.1L14.7 3H9.3l-.4 2.9A7.4 7.4 0 0 0 7 7L4.7 6l-2 3.4 2 1.5a7.4 7.4 0 0 0 0 2.2l-2 1.5 2 3.4 2.3-1a7.4 7.4 0 0 0 1.9 1.1l.4 2.9h5.4l.4-2.9a7.4 7.4 0 0 0 1.9-1.1l2.3 1 2-3.4-2-1.5c.1-.4.1-.7.1-1.1Z',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm9 3-4.3-4.3',
  logout: 'M10 4H5v16h5M14 8l4 4-4 4M18 12H9',
  plus: 'M12 5v14M5 12h14',
  close: 'M6 6l12 12M18 6 6 18',
  check: 'm5 12 4 4L19 6',
  chevronRight: 'm9 6 6 6-6 6',
  chevronLeft: 'm15 6-6 6 6 6',
  edit: 'M4 20h4l10-10-4-4L4 16v4ZM13 7l4 4',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6',
  refresh: 'M20 12a8 8 0 0 1-14.9 4M4 12a8 8 0 0 1 14.9-4M4 4v4h4M20 20v-4h-4',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-11v6M12 7h.01',
  lock: 'M6 11V8a6 6 0 0 1 12 0v3M5 11h14v10H5zM12 15v3',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  copy: 'M9 9h10v12H9zM5 15V3h10',
  filter: 'M3 5h18l-7 8v6l-4 2v-8L3 5Z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-14v5l3 2',
  monitor: 'M3 5h18v11H3zM8 20h8M12 16v4',
  key2: 'M8 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm4-4h9',
};

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 19,
  style,
  className,
}: {
  name: IconName;
  size?: number;
  style?: CSSProperties;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={style}
      className={className}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
